module.exports = __webpack_public_path__ + "img/active-c.fd4384c1.png";